import React from "react";

export default class WebCnDate extends React.Component {
  render() {
    const { Bs, VARIANT, dataCN } = this.props;
    return (
      <>
        {dataCN && (
          <Bs col xs={12} md={6} lg={4} className="mb-2">
            <Bs row className="mb-2">
              <Bs b>Data</Bs>
            </Bs>
            <Bs row>
              <Bs small>
                <Bs b>VYTVOŘENO </Bs> {new Date(dataCN[0]?.DateCreate).toLocaleDateString()}
              </Bs>
            </Bs>
            <Bs row>
              <Bs small>
                <Bs b>PLATNOST DO </Bs> {new Date(dataCN[0]?.DateDeadLine).toLocaleDateString()}
              </Bs>
            </Bs>
            <Bs row>
              <Bs small>
                <Bs b>CCA ZHOTOVENÍ </Bs> {new Date(dataCN[0]?.DateDeadLine).toLocaleDateString()}
              </Bs>
            </Bs>
            <Bs row>
              <Bs small>
                <Bs b>AKTUÁLNÍ </Bs> {new Date().toLocaleDateString()}
              </Bs>
            </Bs>
          </Bs>
        )}
      </>
    );
  }
}
